function getZoomLevel() {
    if (navigator.userAgent.includes("Mac")) {
        return window.outerWidth / window.innerWidth;
    }
    return window.devicePixelRatio;
}

function Zoom() {
    const zoom = getZoomLevel()
    return (
        <div className="information_card">
            <h3>Zoom level</h3>
            <p className="information" data-zoom-level={Math.round(zoom * 100) + '%'}>{Math.round(zoom * 100)}%</p>
        </div>
    );
}

export default Zoom;